import getWindow, { getNavigator } from '../get-window';

export function isMobile() {
  const $window = getWindow();
  const { orientation } = $window;

  return typeof orientation !== 'undefined';
}

// Returns if userAgent acessing application starts with certain app name
// You can set your react-native application userAgent like:
// https://github.com/loggi/consumer-app/blob/819d9214d350b87ca3c758c729fb2e0955b0e4de/app/shared/user-agent/index.js
export function isMobileApp(appName) {
  const $navigator = getNavigator();
  const { userAgent = '' } = $navigator;

  return userAgent.startsWith(appName);
}

export function userAgentIncludes(string) {
  const $navigator = getNavigator();
  const { userAgent = '' } = $navigator;

  return userAgent.includes(string);
}

export function getVersionsToCompare(version1, version2) {
  const numberV1 = version1.replace(/\./g, '');
  const numberV2 = version2.replace(/\./g, '');
  const maxLength = Math.max(numberV1.length, numberV2.length);
  const navigatorVersionToCompare =
    numberV1 * 10 ** (maxLength - numberV1.length);
  const baseVersionToCompare = numberV2 * 10 ** (maxLength - numberV2.length);
  return {
    navigatorVersionToCompare,
    baseVersionToCompare
  };
}

export const compareAppVersions = baseVersion => {
  const $navigator = getNavigator();
  const navigatorVersion = $navigator.appVersion.substr(
    0,
    $navigator.appVersion.indexOf('(')
  );
  const versionToCompare = baseVersion.toString();
  return getVersionsToCompare(navigatorVersion, versionToCompare);
};

export const isConsumerApp = () => isMobileApp('ConsumerApp');
export const isVersion = version => userAgentIncludes(`/${version}`);
export const isAndroidApp = () => userAgentIncludes('Loggi-Android;');
export const isIOSApp = () => userAgentIncludes('Loggi-iOS;');
export const isHeaderlessApp = () => userAgentIncludes('no-loggi-header');

export const hasGreaterOrSameIOSVersion = version => {
  const {
    navigatorVersionToCompare,
    baseVersionToCompare
  } = compareAppVersions(
    // Base iOS app version that implemented native screen.
    version
  );
  return (
    isConsumerApp() &&
    navigatorVersionToCompare >= baseVersionToCompare &&
    isIOSApp()
  );
};
